import React from "react";
import { Menu, MenuItem } from "@blueprintjs/core";
export default function MainNavItems({ items, selected, onItemClick }) {
  return (
    <Menu className="main-navigation">
      {items.map(item => {
        let isActive = false;

        let has_notification = false;
        if (item.unread_conversations && Boolean(item.unread_conversations.length)) {
          has_notification = true;
        }

        if (item.new_notifications && Boolean(item.new_notifications.length)) {
          has_notification = true;
        }

        if (selected.indexOf(item.slug) !== -1) {
          isActive = true;
        }
        return (
          <React.Fragment key={item.slug}>
            <MenuItem
              onClick={_ => {
                onItemClick(item.slug);
              }}
              active={isActive}
              icon={item.icon}
              text={item.label}
              className={`${has_notification ? "menu-item has-notification" : "menu-item"}`}
            />
          </React.Fragment>
        );
      })}
    </Menu>
  );
}
